<template>
  <div
    id="atom"
    :style="{
      width: 'calc(1080px * ' + itemStyle.width + '/100)',
      height: 'calc(1080px * ' + itemStyle.width + '/100)',
      top: itemStyle.top + '%',
      left: itemStyle.left + '%',
      position: 'fixed',
    }"
  >
    <img class="imgAtom" src="./assets/atom.png" />
    <svg
      id="atomSvg"
      viewBox="0 0 800 800"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path
          id="svg_10"
          d="m196.929348,77.192231"
          opacity="0.5"
          fill-opacity="null"
          stroke-opacity="null"
          stroke-width="1.5"
          stroke="transparent"
          fill="none"
        />
        <path
          id="svg_13"
          d="m291.88086,369.23091l2.98952,-55.5572l7.69227,-46.15363l13.67515,-55.55529l17.94863,-42.73483l20.51272,-33.33318l25.6409,-17.94863l22.22212,-4.27348c0.42927,0.00192 23.50608,6.83949 23.50608,7.69419c0,0.85469 23.07681,20.51272 22.64754,20.5108c0.42927,0.00192 20.0873,36.75388 19.65803,36.75196c0.42927,0.00192 12.39502,32.48039 13.24972,33.33509c0.85469,0.8547 17.09393,72.64922 16.66466,72.64731c0.42927,0.00191 7.26685,59.83068 6.83758,59.82877c0.42927,0.00191 2.13866,48.71963 1.70939,48.71771c0.42927,0.00192 1.28397,39.31797 0.8547,39.31605c0.42927,0.00192 -2.13482,38.46327 -2.56409,38.46136c0.42927,0.00191 -10.68179,70.08704 -11.11106,70.08513c0.42927,0.00191 -14.95527,50.42902 -15.38454,50.42711c0.42927,0.00191 -17.51936,47.01023 -17.94863,47.00832c0.42927,0.00191 -20.93815,27.35221 -21.36742,27.3503c0.42927,0.00191 -25.21164,16.24114 -25.6409,16.23923c0.42926,0.00191 -34.6133,0.85661 -35.04257,0.8547c0.42927,0.00191 -33.7586,-36.75005 -34.18787,-36.75196c0.42927,0.00191 -27.77572,-61.53625 -28.20499,-61.53817c0.42927,0.00192 -17.51936,-74.3567 -17.94864,-74.35861c0.42928,0.00191 -7.26299,-91.45064 -7.69227,-91.45255c0.42928,0.00191 3.84568,-1.70986 1.28397,-49.5705z"
          fill-opacity="null"
          stroke-opacity="null"
          stroke-width="1.5"
          stroke="transparent"
          fill="none"
        />
        <path
          id="svg_14"
          d="m197.009525,193.911244l23.502235,-11.860837l43.589534,1.709393l32.478477,11.965755l52.136501,24.786205l41.025444,25.640903l49.572411,43.589534l44.444231,37.606657l58.119379,70.085133l33.333173,48.717714l25.640902,52.136502l11.965755,37.606657l2.56409,22.222115l-0.854697,17.093935l-5.12818,18.803328l-13.675148,11.965755l-18.803328,8.546967l-22.222116,0.854697l-29.914386,-4.273484c0.429268,0.749772 -38.032085,-16.344163 -39.741478,-15.489466c-1.709394,0.854697 -52.136501,-29.059689 -52.565771,-29.809461c0.42927,0.749772 -55.980714,-41.130368 -56.409985,-41.880141c0.429271,0.749773 -32.903902,-28.309915 -33.333173,-29.059689c0.429271,0.749774 -33.758598,-33.438096 -34.18787,-34.18787c0.429272,0.749774 -37.177384,-41.130366 -37.606657,-41.88014c0.429273,0.749774 -32.049203,-41.985062 -32.478476,-42.734838c0.429273,0.749776 -23.502235,-37.711577 -23.931509,-38.461353c0.429274,0.749776 -18.374054,-41.98506 -18.803328,-42.734838c0.429274,0.749778 -12.391177,-36.856879 -12.820451,-37.606656c0.429274,0.749777 -0.425423,-18.908247 -0.854697,-19.658026c0.429274,0.749779 2.138667,-17.198853 1.709393,-17.948631c0.429274,0.749778 8.121545,-18.05355 7.692271,-18.803329c0.429274,0.749779 2.138667,-0.852778 5.557454,-6.942491z"
          fill-opacity="null"
          stroke-opacity="null"
          stroke-width="1.5"
          stroke="transparent"
          fill="none"
        />
        <path
          id="svg_15"
          d="m417.521282,241.024477l50.852535,-29.914381l44.444231,-20.512722l50.427108,-10.256361c0.429267,0.854693 20.087292,7.692267 20.941988,7.692267c0.854697,0 17.093935,5.982877 16.664668,5.128185c0.429267,0.854692 9.830931,15.384537 9.401665,14.529844c0.429266,0.854693 4.70275,19.658021 4.273483,18.803329c0.429267,0.854692 0.429267,24.7862 0,23.931509c0.429267,0.854691 -6.408307,34.187864 -6.837574,33.333173c0.429267,0.854691 -4.698914,19.658019 -6.408307,20.512715c-1.709394,0.854697 -18.803328,35.897263 -19.232595,35.042573c0.429267,0.85469 -21.792848,38.461346 -22.222115,37.606657c0.429267,0.854689 -26.066332,36.751952 -26.4956,35.897263c0.429268,0.854689 -32.903904,41.025435 -33.333173,40.170747c0.429269,0.854688 -39.741478,39.316041 -40.170747,38.461354c0.429269,0.854687 -69.655863,58.974065 -70.085133,58.119379c0.42927,0.854686 -49.14314,33.333161 -49.572411,32.478476c0.429271,0.854685 -34.613295,17.093923 -35.042567,16.239238c0.429272,0.854685 -27.77572,11.965743 -28.204992,11.111058c0.429272,0.854685 -24.356933,5.982865 -24.786206,5.12818c0.429273,0.854685 -26.066326,-1.709405 -26.495599,-2.56409c0.429273,0.854685 -25.211629,-11.111069 -25.640902,-11.965754c0.429273,0.854685 -12.391178,-20.512733 -12.820452,-21.367419c0.429274,0.854686 -0.425422,-34.18788 -0.854696,-35.042567c0.429274,0.854687 10.685634,-45.298937 10.256361,-46.153624c0.429273,0.854687 22.651388,-39.316059 22.222115,-40.170747c0.429273,0.854688 29.488962,-46.153632 29.059689,-47.008321c0.429273,0.854689 26.070175,-32.478484 25.640903,-33.333173c0.429272,0.854689 45.728199,-50.427115 45.298927,-51.281805c0.429272,0.85469 53.420469,-47.008327 52.991198,-47.863018c0.429271,0.854691 5.557452,-4.378402 45.728198,-36.751965z"
          fill-opacity="null"
          stroke-opacity="null"
          stroke-width="1.5"
          stroke="transparent"
          fill="none"
        />
        <path
          id="svg_16"
          fill-opacity="null"
          stroke-opacity="null"
          stroke-width="1.5"
          stroke="transparent"
          fill="none"
        />
        <path
          id="svg_17"
          d="m114.103943,395.724586l5.553601,29.059697l23.931509,23.076812l34.18787,19.658025l23.076812,11.965754l44.444231,10.256361l65.81165,14.529845l55.555288,1.709394l56.409985,-0.854697l52.136502,-0.854697l92.307248,-17.093935l45.298928,-12.820451l41.88014,-22.222115l23.076813,-25.640903l8.546967,-20.512722l0,-23.931509l-19.658025,-22.222115c0.429265,0.85469 -37.177391,-27.350303 -37.177391,-26.495606c0,0.854697 -66.666345,-23.076812 -67.095612,-23.931502c0.429267,0.85469 -49.99784,-9.40167 -50.427108,-10.256361c0.429268,0.854691 -35.467995,-3.418793 -35.897264,-4.273484c0.429269,0.854691 -53.416625,-4.273489 -53.845895,-5.12818c0.42927,0.854691 -49.14314,1.709387 -49.572411,0.854697c0.429271,0.85469 -43.160262,3.418781 -43.589534,2.56409c0.429272,0.854691 -44.014958,8.546961 -44.444231,7.692271c0.429273,0.85469 -26.921023,7.692264 -27.350295,6.837574c0.429272,0.85469 -35.46799,8.546961 -35.897264,7.69227c0.429274,0.854691 -28.630415,11.111051 -29.059689,10.256361c0.429274,0.85469 -26.066325,11.965748 -26.495599,11.111058c0.429274,0.85469 -22.647538,18.803321 -23.076812,17.948632c0.429274,0.854689 -10.681783,8.54696 -11.111058,7.69227c0.429275,0.85469 -8.972389,15.384534 -9.401664,14.529845c0.429275,0.854689 -8.117692,6.837566 -8.117692,18.803321z"
          fill-opacity="null"
          stroke-opacity="null"
          stroke-width="1.5"
          stroke="transparent"
          fill="none"
        />
        <circle r="10" fill="#529fd9">
          <animateMotion dur="2.5s" repeatCount="indefinite">
            <mpath xlink:href="#svg_13" />
          </animateMotion>
        </circle>
        <circle r="10" fill="#529fd9">
          <animateMotion dur="2.4s" repeatCount="indefinite">
            <mpath xlink:href="#svg_14" />
          </animateMotion>
        </circle>
        <circle r="10" fill="#529fd9">
          <animateMotion dur="2.3s" repeatCount="indefinite">
            <mpath xlink:href="#svg_15" />
          </animateMotion>
        </circle>
        <circle r="10" fill="#529fd9">
          <animateMotion dur="2.1s" repeatCount="indefinite">
            <mpath xlink:href="#svg_17" />
          </animateMotion>
        </circle>
      </g>
    </svg>
    <!-- </transition> -->
  </div>
</template>
<script>
export default {
  name: 'atom',
  props: {
    itemStyle: {
      default: () => {
        return null;
      },
      type: Object,
    },
  },
  data() {
    return {
      image: '../../../assets/img/atom.png',
    };
  },
};
</script>
<style lang="sass">
@import '../../style/base'
@import '../../style/animation'
#atom
  position: fixed
  #atomSvg
    position: absolute
    width: 90%
    left: 0
    top: 0
    height: 90%
    //transform-origin: center
  .imgAtom
    //transform-origin: center
    position: absolute
    width: 90%
    height: 90%
    left: 0
    top: 0
</style>
